export default "__VITE_ASSET__EOAR7Vy4__"